export { default as windowSizeSlice } from './windowSize.slice';
export { setWindowSize } from './windowSize.slice';
